<template>
  <div>
    <v-dialog
      fullscreen
      @keydown.esc="close()"
      :value="value"
      @input="emitInput($event.target.value)"
    >
      <v-card color="grey lighten-3">
        <v-toolbar dark :color="$store.state.global.pages.allocation.color">
          <v-btn icon dark @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add Batch Allocations</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-container grid-list-xl fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <batch-allocation-control @addedBatch="$emit('addedBatch')"></batch-allocation-control>
            </v-flex>
            <v-flex xs12>
              <batch-allocation-view></batch-allocation-view>
            </v-flex>
          </v-layout>
          <snack-bar ref="snackbar"></snack-bar>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import BatchAllocationControl from "./batchAllocationControl";
import BatchAllocationView from "./batchAllocationView";
export default {
  data() {
    return {
      queryDialog: false
    };
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    emitInput(val) {
      this.$store.commit("dockets/setState", {
        prop: "creditData",
        value: null
      });
      this.$emit("input", val);
    },
    addedBatch() {
      alert("Added Batch");
      this.queryDialog = true;
    },
    addAnother() {
      this.queryDialog = false;
      this.emitInput(true);
    },
    quit() {
      this.$store.dispatch("dockets/resetFormFull");
      this.queryDialog = false;
    }
  },
  computed: {},
  props: {
    value: Boolean
  },
  components: {
    BatchAllocationControl,
    BatchAllocationView
  }
};
</script>

<style>
</style>
